import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setIsAuthenticated, setLoading, setUser } from '../features/userSlice';
import { baseQueryWithCsrf } from "./baseQueryWithCsrf";

export const userApi = createApi({
    reducerPath: 'userApi',
    baseQuery: baseQueryWithCsrf,
    tagTypes: ["User", "AdminUsers", "AdminUser"],
    endpoints: (builder) => ({

        getMe: builder.query({
            query: (id) => `/me`,
            transformResponse: (result) => result.user,
            async onQueryStarted(args, { dispatch, queryFulfilled }){
                try {
                   const {data} = await queryFulfilled;
                   dispatch(setUser(data));
                   dispatch(setIsAuthenticated(true));
                   dispatch(setLoading(false))
                } catch (error) {
                    dispatch(setLoading(false))
                    console.log(error);
                }
            },
            providesTags: (result, error, id) => [{ type: 'User', id }],
            }),

            updateProfile: builder.mutation({
                query(body) {
                  return{
                    url: "/me/update",
                    method: "PUT",
                    body,
                  };
                },
                invalidatesTags: ['User']
        }),

    updatePassword: builder.mutation({
      query(body) {
        return{
          url: "/password/update",
          method: "PUT",
          body,
        };
      },
}),
forgotPassword: builder.mutation({
  query(body) {
    return{
      url: "/password/forgot",
      method: "POST",
      body,
    };
  },
}),

resetPassword: builder.mutation({
  query({ token, body }) {
    return{
      url: `/password/reset/${token}`,
      method: "PUT",
      body,
    };
  },
  invalidatesTags: ['User']
}),

getAdminUsers: builder.query({
  query: () => `/admin/users`,
  providesTags: (result, error, id) => [{ type: 'AdminUsers', id }],
}),

getUserDetails: builder.query({
  query: (id) => `/admin/users/${id}`,
  providesTags: (result, error, id) => [{ type: 'AdminUsers', id }],

  invalidatesTags: ["AdminUsers"]
}),

deleteUser: builder.mutation({
  query(id) {
    return {
      url: `/admin/users/${id}`,
      method: "DELETE",
    };
  },
  invalidatesTags: ["AdminUsers"],
}),

updateUser: builder.mutation({
  query({ id, body }) {
    return {
      url: `/admin/users/${id}`,
      method: "PUT",
      body,
    };
  },
  invalidatesTags: ["AdminUsers"],
}),

updateUserLocation: builder.mutation({
  query(body) {
    return{
      url: "/me/location",
      method: "PUT",
      body,
    };
  },
  invalidatesTags: ['AdminUsers']
}),
 

 

}),
});

export const { 
  useGetMeQuery, 
  useUpdateProfileMutation, 
  useUpdatePasswordMutation, 
  useForgotPasswordMutation, 
  useResetPasswordMutation,
  useGetAdminUsersQuery,
  useGetUserDetailsQuery,
  useDeleteUserMutation,
  useUpdateUserMutation,
  useUpdateUserLocationMutation,
} = userApi;